'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _pure = require('recompose/pure');

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = require('material-ui/SvgIcon');

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SvgIconCustom = global.__MUI_SvgIcon__ || _SvgIcon2.default;

var _ref = _react2.default.createElement('path', { d: 'M5 13.18v4L12 21l7-3.82v-4L12 17l-7-3.82zM12 3L1 9l11 6 9-4.91V17h2V9L12 3z' });

var School = function School(props) {
  return _react2.default.createElement(
    SvgIconCustom,
    props,
    _ref
  );
};

School = (0, _pure2.default)(School);
School.muiName = 'SvgIcon';

exports.default = School;


//////////////////
// WEBPACK FOOTER
// ./~/material-ui-icons/School.js
// module id = 2797
// module chunks = 0